import React from 'react';
import { useAuth } from '../../Components/AuthContext';
import { useLayout } from './LayoutContext';
import styles from './Header.module.css';

const Header: React.FC = () => {
  const { user } = useAuth();
  const { headerActions, headerContent, hideHeader } = useLayout();

  // Páginas con su propio header (ej. GuideDetail) lo ocultan por completo
  if (hideHeader) return null;

  // Si una página define headerContent, reemplaza el header por defecto
  if (headerContent) {
    return <div className={styles.headerCustom}>{headerContent}</div>;
  }

  return (
    <header className={styles.header}>
      <p className={styles.welcome}>
        Welcome, <span className={styles.name}>{user?.name || 'User'}</span>
      </p>
      <div className={styles.actions}>{headerActions}</div>
    </header>
  );
};

export default Header;
